import { FormErrorCode } from '@bit-box/common';
import type { LocaleResources } from '../types';

/**
 * English error messages corresponding to FormErrorCode
 * Placeholders in {key} format are replaced with ctx values.
 */
export const FormErrorMessages: LocaleResources['FormErrorMessages'] = {
  // Signal related
  [FormErrorCode.SIGNAL_NOT_SELECTED]: 'Please select a signal.',
  [FormErrorCode.SIGNAL_NO_CONDITIONS]: 'Signal type [{signalTypeName}] has no conditions yet.',
  [FormErrorCode.SIGNAL_DUPLICATE]: 'Signal is duplicated.',

  // Amount/Ratio related
  [FormErrorCode.AMOUNT_INVALID]: 'Amount must be a valid number between 0 and 100.',
  [FormErrorCode.AMOUNT_RATIO_INVALID]: 'Exit ratio must be a valid number between 0 and 100.',
  [FormErrorCode.ENTER_AMOUNT_SUM_NOT_100]: 'The sum of entry amount ratios in {triggerType} must equal 100%.',
  [FormErrorCode.EXIT_LAST_AMOUNT_NOT_100]: 'The last exit step ratio must be fixed at 100%.',
  [FormErrorCode.LAST_AMOUNT_NOT_100]: 'The last step exit ratio must be fixed at 100%.',

  // Trailing exit related
  [FormErrorCode.TRAILING_CHANGE_INVALID]: 'Reference value must be positive.',

  // Exclusive exit related
  [FormErrorCode.EXCLUSIVE_CHANGE_INVALID]: 'Net ROE value in {triggerType} cannot be empty or 0.',
  [FormErrorCode.STOPLOSS_REQUIRED]: 'At least one stop-loss section is required.',
  [FormErrorCode.STOPLOSS_FIRST_AMOUNT_NOT_100]: 'The first stop-loss section amount ratio must be fixed at 100%.',
  [FormErrorCode.TAKEPROFIT_LAST_AMOUNT_NOT_100]:
    'The last take-profit section exit ratio must be 100% if there is no trailing exit step.',

  // Overlapping exit related
  [FormErrorCode.OVERLAPPING_VALUE_INVALID]: 'All input values in step exit sections must be valid numbers.',
  [FormErrorCode.OVERLAPPING_AMOUNT_INVALID]:
    'Exit ratio in step exit sections must be a valid number between 0 and 100.',
  [FormErrorCode.OVERLAPPING_AMOUNT_EXCEED]: 'Exit ratio in step exit sections cannot exceed 100.',
  [FormErrorCode.OVERLAPPING_UP_GREATER_THAN_DOWN]: 'Rising ROE must be greater than falling ROE in the same section.',
  [FormErrorCode.OVERLAPPING_DOWN_ORDER_INVALID]:
    "Falling ROE must be equal to or less than the previous section's rising ROE.",
  [FormErrorCode.OVERLAPPING_UP_ORDER_INVALID]: "Rising ROE must be greater than the previous section's rising ROE.",
  [FormErrorCode.OVERLAPPING_FIRST_DOWN_AMOUNT_NOT_100]: 'The first falling exit ratio must be 100%.',
  [FormErrorCode.OVERLAPPING_LAST_UP_AMOUNT_NOT_100]:
    'The last rising exit ratio must be 100% if there is no trailing exit step.',

  // Condition related
  [FormErrorCode.CONDITION_ID_DUPLICATE]: 'Condition ID ({conditionId}) already exists.',

  // 지표 관련
  [FormErrorCode.INDICATOR_TIMEFRAME_REQUIRED]: 'Timeframe is required.',
};
